'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _utilsList = require('@bibliocommons/utils-list');

var _visibilityIcon = require('../../visibility-icon');

var _visibilityIcon2 = _interopRequireDefault(_visibilityIcon);

var _localeLabel = require('../../locale-label');

var _localeLabel2 = _interopRequireDefault(_localeLabel);

require('../styles/VisibilityStatus.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisibilityStatus = function (_BcReactComponent) {
  _inherits(VisibilityStatus, _BcReactComponent);

  function VisibilityStatus() {
    _classCallCheck(this, VisibilityStatus);

    return _possibleConstructorReturn(this, (VisibilityStatus.__proto__ || Object.getPrototypeOf(VisibilityStatus)).apply(this, arguments));
  }

  _createClass(VisibilityStatus, [{
    key: 'getMessageForLocale',
    value: function getMessageForLocale() {
      var locale = this.props.list.get('intendedLocale');
      if (locale === 'library') {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'your_library' });
      }

      return this.props.listLocales.get(locale);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          listLocales = _props.listLocales;

      var type = (0, _utilsList.getListVisibilityType)(list);
      var localeLabel = _react2.default.createElement(_localeLabel2.default, { locale: list.get('intendedLocale'), possibleLocales: listLocales });
      return _react2.default.createElement(
        'div',
        { className: 'cp-visibility-status' },
        _react2.default.createElement(_visibilityIcon2.default, { visibility: type }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'user_list_visibility_status_' + type,
          values: { location: localeLabel } }),
        _react2.default.createElement(
          'div',
          { className: 'visibility-learn-more small' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_visibility_learn_more' })
        )
      );
    }
  }]);

  return VisibilityStatus;
}(_baseBcReactComponent2.default);

exports.default = VisibilityStatus;


VisibilityStatus.propTypes = {
  listLocales: _reactImmutableProptypes2.default.map.isRequired,
  list: _bcPropTypes.listShape.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-status/components/VisibilityStatus.component.js
// module id = 1356
// module chunks = 0